import ProductDescription from './ProductDescription'

const WheatTortillaProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '008',
  IsBroadband: false,
  Size: '',
}

export default WheatTortillaProduct
